import { Avatar, Box, Divider, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { User } from "@/types/auth";

interface UserProfileProps {
  user: User;
}

export const UserProfile: React.FC<UserProfileProps> = ({ user }) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Avatar
          sx={{
            width: 40,
            height: 40,
            bgcolor: "primary.main",
            color: "common.white",
            fontWeight: 600,
            fontSize: "1rem",
          }}
        >
          {user.firstName?.charAt(0) || user.email?.charAt(0) || "U"}
        </Avatar>
        <Box sx={{ ml: 2 }}>
          <Typography
            variant="body2"
            fontWeight={600}
            sx={{
              fontSize: "0.9rem",
              color: "text.primary",
            }}
          >
            {user.firstName ? `${user.firstName} ${user.lastName || ""}` : t("common.user")}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              fontSize: "0.8rem",
              fontWeight: 400,
            }}
          >
            {user.email || ""}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ my: 1, mx: 2 }} />
    </>
  );
};
